import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './login.css'; 
import logos from './assets/nSure_CSSH_LOGO.svg';
import logo from './assets/Untitled-10.png';
import nordic from './assets/NH.png'
import pullela from './assets/PULLALA.png'



function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://nsureback.asianspinehospital.com/login', formData);
      localStorage.setItem('formData', JSON.stringify(formData));
      alert(response.data.message);
      navigate('/profile');
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Error logging in.');
    }
  };

  return (
    <div className="loginPage">
  <div className="leftside">
    
    <div>
      <img src={logo}  alt="logo" />
      </div>
    <div>
    <h2>India's First Integrated Preventive <br/>SPINE & SPORTS Healthcare Center</h2>
    </div>
    <div>
      <span>
 In Partnership With
      </span>
      <span>
      <img src={nordic}  alt="logo" />
      </span>
      <span>  <img src={pullela}  alt="logo" /></span>

    </div>

  </div>
      <div className="loginContainer">
      <img src={logos} alt=''/>

        <h3>Admin</h3>
        {errorMessage && <p className="error">{errorMessage}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
          <button type="submit" className='button'>Login</button>
        </form>
      </div>
     
    </div>
  );
}

export default Login;
